import { FaEdit, FaSave } from 'react-icons/fa';
import { MdOutlineCancel } from "react-icons/md";
import { FaArrowDownLong, FaArrowUpLong  } from "react-icons/fa6";
import { IoMdPersonAdd } from "react-icons/io";
import { memo } from 'react';
export const EditIcon = memo(({loading, disabled, onClick, className, btnName = "Edit"}) => {
        return (
            <button disabled={disabled} onClick={onClick} className={`absolute flex items-center px-1 shadow border border-gray-300 bg-yellow-100 hover:bg-yellow-200 rounded-lg transition duration-300 ease-in-out w-fit ${className} z-[11]`} >
                <FaEdit className=" text-yellow-600 p-2 h-9 w-9" /> <span className=' font-bold text-yellow-600 pr-2'>{loading ? "loading..." : btnName}</span>
            </button>
        );
})
export const SaveIcon = memo(({loading, disabled, onClick, className, btnName = "Save"}) => {
        return (
            <button disabled={disabled} onClick={onClick} className={`absolute flex items-center px-1 shadow border border-gray-300 bg-green-100 rounded-lg  ${disabled ? " cursor-not-allowed" : " cursor-pointer hover:bg-green-200 transition duration-300 ease-in-out"}  w-fit ${className} z-[11]`} >
                <FaSave className={`${disabled ? "text-green-400" : "text-green-600"} p-2 h-9 w-9`} /> <span className={`font-bold ${disabled ? "text-green-400" : "text-green-600"}  pr-2`}>{loading ? "loading..." : btnName}</span>
            </button>
        );
})
export const AddIcon = memo(({loading, disabled, onClick, className, btnName = "Add"}) => {
        return (
            <button disabled={disabled} onClick={onClick} className={`absolute flex items-center px-1 shadow border border-gray-300 bg-blue-100 hover:bg-blue-200 rounded-lg transition duration-300 ease-in-out w-fit ${className} z-[11]`} >
                <IoMdPersonAdd className=" text-blue-600 p-2 h-9 w-9" /> <span className=' font-bold text-blue-600 pr-2'>{loading ? "loading..." : btnName}</span>
            </button>
        );
})
export const CancelIcon = memo(({loading, disabled, onClick, className, btnName = "Cancel"}) => {
        return (
            <button disabled={disabled} onClick={onClick} className={`absolute flex items-center px-1 shadow border border-gray-300 bg-orange-100 hover:bg-orange-200 rounded-lg transition duration-300 ease-in-out w-fit ${className} z-[11]`} >
                <MdOutlineCancel className=" text-orange-600 p-2 h-9 w-9" /> <span className=' font-bold text-orange-600 pr-2'>{loading ? "loading..." : btnName}</span>
            </button>
        );
})

export const UpDownArrow = memo(({ upArrowColor, downArrowColor })=> {
    return (
        <div className='flex items-center'>
            <FaArrowUpLong className={`w-4 h-4 ${upArrowColor}`} />
            <FaArrowDownLong className={`w-4 h-4 -ml-2 ${downArrowColor}`} />
        </div>
    )
})